import React from "react";
import { Input } from "@material/react-text-field";
import { v4 } from "uuid";

type AutofillDisabledInputProps = Omit<
  React.ComponentProps<typeof Input<HTMLInputElement>>,
  "ref"
> & {
  ref?:
    | React.RefObject<Input<HTMLInputElement>>
    | React.Ref<Input<HTMLInputElement>>;
};

export const randomizeName = (name?: string): string => {
  return `${name}${v4()}`;
};

export const AutofillDisabledInput: React.FC<AutofillDisabledInputProps> = ({
  name,
  ...props
}) => {
  const randomizedName = randomizeName(name);

  return (
    <Input
      {...props}
      ref={props.ref as any}
      name={randomizedName}
      autoComplete="new-password"
    />
  );
};
